var indexOf = [].indexOf;

angular.module('gym.components').directive('customFormSection', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/forms/custom_form_section.html.slim'),
    scope: {
      contact: '=',
      form: '=',
      editForm: '&'
    },
    controller: ["$scope", "FormFieldDisplayingService", function($scope, FormFieldDisplayingService) {
      $scope.params = {};
      $scope.isWaiverAnswers = $scope.form.name === 'waiver_answers';
      $scope.isFieldAvailable = function(field) {
        if ($scope.isWaiverAnswers && !$scope.params.blankVisible && !$scope.contact[$scope.form.name][field.name]) {
          return false;
        }
        return FormFieldDisplayingService.isDisplaying($scope.contact.type, field);
      };
      return $scope.isFormCompact = function() {
        var compactFields, ref;
        compactFields = ['unsubscribes', 'marketing_information', 'body_composition', 'key_demographics', 'fitness_goals'];
        return ref = $scope.form.name, indexOf.call(compactFields, ref) >= 0;
      };
    }]
  };
});
